import { BaseResource } from 'utils/ApiUtils';

export default class InspectionReport extends BaseResource {
  constructor(args) {
    super(args, InspectionReport.attributes);
    this.date = new Date(this.date).toISOString();
  };

  static columns = [
    { title: "date", field: "date", type: "date" },
    { title: "isSigned", field: "isSigned", type: "string" },
    { title: "url", field: "url", type: "date" }
  ]
  static attributes = InspectionReport.columns.map(r => r.field);

};